/* ==========================================================================
   PizzAmica — le pizze che ruotano nel carosello

   Si accende mettendo `pizza-spin` nell'Extra class name della ROW (o della
   colonna) che contiene il carosello: l'elemento Carousel di Salient quel
   campo non ce l'ha.

   La rotazione e legata alla POSIZIONE del nastro, non alla sua velocita. E
   la stessa idea della pizza che segue lo scroll, e da sola copre i tre casi
   senza scriverli uno per uno: nastro fermo, posizione ferma, pizze ferme;
   ticker lento, rotazione lenta; trascinamento veloce, rotazione veloce. E
   trascinando all'indietro girano all'indietro, che con una formula basata
   sulla velocita non verrebbe.

   Non ci si appoggia all'istanza di Flickity: Salient monta i caroselli solo
   quando entrano in vista, quindi al caricamento `Flickity.data()` non
   restituisce ancora niente. Si misura di quanto il nastro e scivolato dentro
   la sua finestra.
   ========================================================================== */ (function() {
    'use strict';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function init() {
        Array.prototype.forEach.call(document.querySelectorAll('.pizza-spin'), setup);
    }
    function setup(scope) {
        // La classe puo stare sul carosello o su un suo antenato (row, colonna)
        var root = scope.classList.contains('nectar-flickity') ? scope : scope.querySelector('.nectar-flickity');
        if (!root) return;
        var viewport = null;
        var slider = null;
        var imgs = [];
        var running = false;
        var lastX = null;
        var perPx = 0;
        // Un giro completo ogni larghezza di schermo. Il numero di giri e la
        // manopola in _carousel.scss; da ricalcolare al resize, perche dipende
        // dalla larghezza della finestra.
        function measure() {
            var turns = parseFloat(getComputedStyle(scope).getPropertyValue('--pizza-spin-turns'));
            if (!isFinite(turns) || turns <= 0) turns = 1;
            perPx = 360 * turns / Math.max(window.innerWidth, 1);
            lastX = null; // forza una riscrittura col nuovo fattore
        }
        // Il carosello nasce dopo: finche Salient non lo monta, non c'e nastro
        function ready() {
            viewport = root.querySelector('.flickity-viewport');
            slider = root.querySelector('.flickity-slider');
            if (!viewport || !slider) return false;
            var found = root.querySelectorAll('.cell img');
            if (!found.length) {
                slider = null;
                return false;
            }
            imgs = Array.prototype.slice.call(found);
            return true;
        }
        // Quanto il nastro e scivolato dentro la finestra, in pixel. Passare dai
        // rettangoli invece che dalla transform evita di dover indovinare se
        // Flickity stia usando px o percentuali, e non risente dello scroll di
        // pagina perche le due misure si muovono insieme.
        function shift() {
            return slider.getBoundingClientRect().left - viewport.getBoundingClientRect().left;
        }
        function frame() {
            if (!running) return;
            if (slider || ready()) {
                var x = shift();
                // Nastro fermo: nessuna scrittura, nessun lavoro di layout
                if (x !== lastX) {
                    lastX = x;
                    var deg = -x * perPx;
                    for(var i = 0; i < imgs.length; i++)// Ogni pizza parte da un angolo suo: girano insieme ma non
                    // sembrano un unico blocco rigido
                    imgs[i].style.rotate = (deg + i * 37).toFixed(2) + 'deg';
                }
            }
            requestAnimationFrame(frame);
        }
        function start() {
            if (running) return;
            running = true;
            requestAnimationFrame(frame);
        }
        function stop() {
            running = false;
        }
        measure();
        var resizeTimer = null;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(measure, 200);
        });
        // Fuori schermo non gira niente: il ticker di Salient e continuo, e senza
        // questo il loop resterebbe acceso per tutta la pagina.
        if (window.IntersectionObserver) new IntersectionObserver(function(entries) {
            entries.forEach(function(e) {
                if (e.isIntersecting) start();
                else stop();
            });
        }, {
            rootMargin: '200px 0px'
        }).observe(root);
        else start();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();

//# sourceMappingURL=carousel.js.map
